import { Link } from "react-router-dom";

export function WhoFor() {
  return (
    <section className="landing-section landing-band" id="audience">
      <div className="landing-wrap">
        <div className="section-head">
          <span className="section-eyebrow">Who it&apos;s for</span>
          <h2 className="section-title">Two jobs. One harness.</h2>
        </div>

        <div className="fork-grid">
          {/* Engineers — rigorous register */}
          <div className="fork-col fork-col--eng" id="for-engineers">
            <span className="fork-tag">For engineers</span>
            <h3 className="fork-title">Defend every decision you stamp.</h3>
            <p className="fork-lead">
              Speed without losing the trail. Every load, member, and override traces to its
              governing clause and edition. AI handles the velocity; you keep the judgment.
              The liability stays where the license is.
            </p>
            <ul className="fork-list">
              <li>Governing case flagged on every member</li>
              <li>Cited clauses + editions, exportable as a calc record</li>
              <li>A full audit trail: who approved what, and when</li>
              <li>Stamp-ready packages; AI never carries the stamp</li>
            </ul>
            <Link to="/beta?intent=demo" className="btn btn-primary fork-cta">Book a demo for your firm</Link>
          </div>

          {/* Builders — warmer, simpler register */}
          <div className="fork-col" id="for-builders">
            <span className="fork-tag">For builders</span>
            <h3 className="fork-title">Permit-ready plans, lot after lot.</h3>
            <p className="fork-lead">
              Set up your master plan once. Every lot gets its own permit-ready calcs in
              minutes, not another week of back-and-forth. Faster to ground, fewer
              surprises, and a licensed PE still signs off.
            </p>
            <ul className="fork-list">
              <li>Reuse one master floor plan across every lot</li>
              <li>Lot-specific calcs auto-generate from the plan</li>
              <li>Fewer rounds of email with the engineer</li>
              <li>A stamped set you can take to the permit desk</li>
            </ul>
            <Link to="/beta?intent=demo" className="btn btn-primary fork-cta">Book a demo for your plans</Link>
          </div>
        </div>
      </div>
    </section>
  );
}
